<template>
  <div class="adv-select-page">
    <div class="flex-wrap">
      <a-select
        show-search
        allow-clear
        :mode="modelType"
        placeholder="请输入名称搜索"
        :value="values"
        :default-active-first-option="false"
        :show-arrow="false"
        :filter-option="false"
        :max-tag-count="maxTag"
        :open="open"
        @search="handleSearch"
        @change="handleChange"
        @focus="handleFocus"
        @blur="handleBlur"
        @deselect="handleDeselect"
        ref="selector"
        option-label-prop="label"
        :disabled="disabled"
      >
      <!-- @deselect="handleBlur" -->
        <a-icon slot="suffixIcon" type="lock" />
        <div slot="notFoundContent">未匹配到任何数据</div>
        <a-select-option :key="-1" v-if="loading">
          <div style="text-align: center">
            <a-spin :spinning="true" />
          </div>
        </a-select-option>
        <template v-else>
          <a-select-option key="all" value="all" v-if="maxTag > 1">
            <!-- 原逻辑 -->
            <!-- <a-icon 
              :type="filteredAdvertisers.length > 0 && values.length === filteredAdvertisers.length ? 'check-circle' : 'check-circle-o'" 
              style="color: #1890ff; margin-right: 8px" 
            /> -->
            <!-- 新逻辑 -->
            <a-icon 
              :type="availableAdvertisers.length > 0 && values.length === availableAdvertisers.length ? 'check-circle' : 'check-circle-o'" 
              style="color: #1890ff; margin-right: 8px" 
            />
            <span style="font-weight: 600">全选</span>
          </a-select-option>
          
          <a-select-option v-for="advertiser in advertisers" :key="advertiser.id" :label="advertiser.name" :disabled="advertiser.is_drift">
            <!-- 原逻辑 -->
            <!-- {{ advertiser.name }} - 【备注：{{ advertiser.remark ? advertiser.remark : advertiser.advertiser_remark }}】 -->
            <!-- 新逻辑 -->
            <a-tooltip 
              v-if="advertiser.is_drift" 
              title="该广告主存在漂移，不可选中" 
              placement="top"
            >
              <span style="color: #999">
                {{ advertiser.name }} - 【备注：{{ advertiser.remark ? advertiser.remark : advertiser.advertiser_remark }}】
                <a-icon type="exclamation-circle" style="color: #f5222d; margin-left: 4px" />
              </span>
            </a-tooltip>
            <span v-else>
              {{ advertiser.name }} - 【备注：{{ advertiser.remark ? advertiser.remark : advertiser.advertiser_remark }}】
            </span>
          </a-select-option>
        </template>
      </a-select>
      <div class="search">
        <a-icon class="icon" v-if="maxTagCount>1 && !disabled" size="small" type="fullscreen" @click="idSearch" />
      </div>
    </div>
    
    <a-modal
      title="批量搜索"
      centered
      :width="640"
      :mask-closable="false"
      :visible="showSearchBox"
      @ok="searchByIds"
      @cancel="closeSearchBox"
    >
      <a-textarea  class="id-box" placeholder="请输入广告主ID，每行一个" :rows="4" v-model="outIds" />
    </a-modal>
  </div>
</template>

<style lang="less" scoped>
@import 'AdvSelect';
</style>

<script>
import AdvSelect from './AdvSelect'
export default AdvSelect
</script>
